import { constants as config } from '@config';

import EditorFacade from '../../facade/editor/editor';
import RestrictionsFacade from '../../facade/restrictions/restrictions';

import BaseView from './components/helper/view';

const handlers = {
  text: require('./element-options/text/handler'),
  table: require('./element-options/table/handler'),
  logo: require('./element-options/vector/handler'),
  qrcode: require('./element-options/vector/handler'),
  sticker: require('./element-options/vector/handler'),
  icon: require('./element-options/vector/handler'),
  shape: require('./element-options/shape/handler'),
  image: require('./element-options/image/handler'),
  video: require('./element-options/video/handler'),
  background: require('./element-options/background/handler')
};

const views = {
  text: require('./element-options/text/view'),
  table: require('./element-options/table/view'),
  logo: require('./element-options/vector/view'),
  qrcode: require('./element-options/vector/view'),
  sticker: require('./element-options/vector/view'),
  icon: require('./element-options/vector/view'),
  shape: require('./element-options/shape/view'),
  image: require('./element-options/image/view'),
  video: require('./element-options/video/view'),
  background: require('./element-options/background/view')
};

const ElementOptionsView = BaseView.extend({
  initialize: function () {
    if (!INKIVE.Helpers.projectIsLinkedToRestrictions()) {
      return;
    }
    BaseView.prototype.initialize.call(this);
    this.render();

    // Not sure about the business logic here, but when I select/deselect a video element,
    // this code is opening some undesired tabs:
    EditorFacade.on('select', _.bind(this.onElementSelection, this));

    function closeOnTabChange ({ button }) {
      if (button !== 'restricted') return;

      INKIVE.EditorFacade.canvas.selectOnly([]);
      INKIVE.EditorFacade.canvas.runExtensions('endEditing', {});
    }

    const close = closeOnTabChange.bind(this);

    EditorFacade
      .off('btn-menu.activate', close)
      .on('btn-menu.activate', close);
  },

  onElementSelection: function (elements) {
    if (this._handleMLSTab()) {
      return;
    }
    const $buttonMLS = $('[href="#tabKWLS"], [href="#tabMLS"], [href="#tabRedfin"]');

    if (elements.length === 1) {
      const selection = elements[0];
      let type = selection.type;

      if (type === 'sticker') {
        type = selection.placeholder
          ? 'image'
          : 'icon';
      }
      const canvas = INKIVE.Tool.getInstance().editor.canvas;

      canvas.runExtensions('selectedChanged', {});
      if ($buttonMLS.length && type === 'text') {
        this.shownTabs.push($buttonMLS.parent().show());
      }

      if (handlers[type] && views[type] && handlers[type].haveOptions(selection)) {
        const toggleRestrictedTab = () => {
          const $colors = this.$el.find('.color-list');
          const $selection = this.$el.find('.selection-list');

          $colors.prepend('<h2>' +
            INKIVE.TranslateHelper.translate('tool.restricted.option.color') +
            '</h2>');
          $selection.prepend('<h2>' +
            INKIVE.TranslateHelper.translate('tool.restricted.option.' + type) +
            '</h2>');

          ($colors.length || $selection.length) && this.$el.removeClass('out').find('.helper-content').scrollTop(0);

          this._toggle(true);
        };

        this.contentView && this.contentView.remove();
        const $chelperContent = this.$el.find('.helper-content');
        $chelperContent.empty();
        this.contentView = new views[type]({
          el: $('<div>').appendTo($chelperContent),
          selection,
          callback: toggleRestrictedTab
        });

        return;
      }
    }

    this._toggle(false, elements);
  },

  _toggle: function (value, elements) {
    let $imagesTab = this.$el.find('.show-images-tab');
    let $iconTab = this.$el.find('.show-icon-tab');
    let $logoTab = this.$el.find('.show-logo-tab');
    let $videoTab = this.$el.find('.show-videos-tab');

    this.shownTabs = this.shownTabs || [];

    const toolPanel = document.querySelector('#tool-panel');
    const toolPanelCollapsed = toolPanel && toolPanel.classList.contains('collapsed');

    if (!value) {
      const hasPermission = RestrictionsFacade.getAllDefaultPermissions();
      // const isHideRestrictionsOverview = RestrictionsFacade.hasAddOnAndFeature(config.featureFlag.addOn, config.featureFlag.keys.restrictionsOverview);

      // if (!toolPanelCollapsed && !isSkipTab() && !isHideRestrictionsOverview && !!elements.length) $('#tool-panel [href=#tabRestricted]').click();

      if (!hasPermission.image_add && !hasPermission.function_use_own_images && !hasPermission.function_use_asset_images && !hasPermission.function_use_desygner_images && !hasPermission.function_use_web_images) {
        $imagesTab.removeClass('show-images-tab');
        $imagesTab = [];
      }
      if (!hasPermission.icon_add && !hasPermission.function_use_asset_vector && !hasPermission.function_use_desygner_vector) {
        $iconTab.removeClass('show-icon-tab');
        $iconTab = [];
      }
      if (!hasPermission.logo_add) {
        $logoTab.removeClass('show-logo-tab');
        $logoTab = [];
      }
      if (!hasPermission.video_add) {
        $videoTab.removeClass('show-videos-tab');
        $videoTab = [];
      }
    }

    if ($imagesTab.length) {
      const $buttonMLS = $('[href="#tabKWLS"], [href="#tabMLS"], [href="#tabRedfin"]');

      if ($buttonMLS.length && value) {
        this.shownTabs.push($buttonMLS.parent().show());
        this.shownTabs.push($('[href="#tabImages"]').parent().show());
      }

      this.$el.toggleClass('show', false);
      const shouldGoToImagesTab = !toolPanelCollapsed && !isSkipTab() && value;
      shouldGoToImagesTab && $('#tool-panel [href=#tabImages]').click();
      INKIVE.EditorFacade.once('tab-image.innertabs', ({ numTabs }) => {
        if (numTabs === 0) {
          $('#tool-panel [href=#tabRestricted]').click();
        }
      });
    } else if ($iconTab.length) {
      this.$el.toggleClass('show', false);
      !toolPanelCollapsed && $('#tool-panel [href=#tabIcons]').click();
    } else if ($logoTab.length) {
      this.$el.toggleClass('show', false);
      !toolPanelCollapsed && $('#tool-panel [href=#tabLogos]').click();
    } else if ($videoTab.length) {
      this.$el.toggleClass('show', false);
      !toolPanelCollapsed && $('#tool-panel [href=#tabVideo]').click();
    } else {
      this.$el.toggleClass('show', value);
      this.$el.toggleClass('out', !value);
      this.trigger('toggle', this.$el.hasClass('show'));

      const activeTab = document.querySelector('#tool-panel .tool-menu li.active');
      if (activeTab && value) {
        activeTab.classList.remove('active');
      }
    }

    function isSkipTab () {
      let skipTab = !!(INKIVE.C.USER.kw_uid) ||
        ['kwls', 'mls', 'redfin'].includes(INKIVE.Helpers.getActiveTab());

      if (!skipTab && (elements && elements.length === 1)) {
        const restrictions = RestrictionsFacade.getElementRestrictions(elements[0].id);
        let type = elements[0].type;

        if (elements[0].texts && Object.entries(elements[0].texts).length) {
          type = 'banner';
        }

        switch (type) {
          case 'text':
            skipTab = !restrictions.length || restrictions[0].text_change_content;
            break;
          case 'banner':
          case 'shape':
            skipTab = true;
            break;
        }
      }
      return skipTab;
    }
  },

  _handleMLSTab: function () {
    if (RestrictionsFacade.getAllDefaultPermissions().image_add) {
      return;
    }

    this.shownTabs = this.shownTabs || [];
    if (this.shownTabs.length) {
      _.each(this.shownTabs, function (btn) {
        btn.children()[0].getAttribute('href') === '#tabRedfin' || btn.hide();
      });
    } else {
      return _.includes(['mls', 'kwls'], INKIVE.Helpers.getActiveTab());
    }

    this.shownTabs = [];
  },

  render: function () {
    this.$el.html(this.template());
  }
});

module.exports = new ElementOptionsView({
  el: $('<div id="element-options">').appendTo('#tool-panel .tool-content')
});
